(() => {
  const storageKey = 'luxury-fashion-wishlist'
  const changeEvent = 'wishlist:change'

  const readWishlist = () => {
    try {
      const storedItems = JSON.parse(localStorage.getItem(storageKey) || '[]')
      if (!Array.isArray(storedItems)) return []

      const handles = new Set()
      return storedItems.filter((item) => {
        if (!item || typeof item.handle !== 'string' || handles.has(item.handle)) return false
        handles.add(item.handle)
        return true
      })
    } catch {
      return []
    }
  }

  const writeWishlist = (items) => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(items))
    } catch {
      return
    }
    document.dispatchEvent(new CustomEvent(changeEvent, { detail: { items } }))
  }

  const updateToggles = (items) => {
    const savedHandles = new Set(items.map((item) => item.handle))

    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const isSaved = savedHandles.has(button.dataset.productHandle)
      button.classList.toggle('is-active', isSaved)
      button.setAttribute('aria-pressed', String(isSaved))
      button.setAttribute('aria-label', isSaved ? button.dataset.removeLabel : button.dataset.addLabel)

      const label = button.querySelector('[data-wishlist-label]')
      if (label) label.textContent = isSaved ? button.dataset.savedText : button.dataset.addText
    })
  }

  const updateHeader = (items) => {
    document.querySelectorAll('[data-wishlist-link]').forEach((link) => {
      const count = items.length
      link.setAttribute('aria-label', link.dataset.countLabel.replace('__COUNT__', String(count)))

      const badge = link.querySelector('[data-wishlist-count]')
      badge.textContent = count
      badge.hidden = count === 0
    })
  }

  const renderWishlistPage = (items) => {
    document.querySelectorAll('[data-wishlist-page]').forEach((page) => {
      const grid = page.querySelector('[data-wishlist-grid]')
      const empty = page.querySelector('[data-wishlist-empty]')
      const template = page.querySelector('[data-wishlist-item-template]')
      if (!grid || !empty || !template) return

      grid.replaceChildren()

      items.forEach((item) => {
        const fragment = template.content.cloneNode(true)
        const productLinks = fragment.querySelectorAll('[data-wishlist-product-link]')
        const image = fragment.querySelector('[data-wishlist-image]')
        const placeholder = fragment.querySelector('[data-wishlist-placeholder]')
        const title = fragment.querySelector('[data-wishlist-title]')
        const price = fragment.querySelector('[data-wishlist-price]')
        const remove = fragment.querySelector('[data-wishlist-remove]')

        productLinks.forEach((link) => { link.href = item.url })
        title.textContent = item.title
        price.textContent = item.price
        remove.dataset.productHandle = item.handle
        remove.setAttribute('aria-label', remove.dataset.removeLabel.replace('__PRODUCT__', item.title))

        if (item.image) {
          image.src = item.image
          image.alt = item.title
          image.hidden = false
          placeholder.hidden = true
        } else {
          image.remove()
        }

        grid.append(fragment)
      })

      const isEmpty = items.length === 0
      empty.hidden = !isEmpty
      grid.hidden = isEmpty
    })
  }

  const refresh = () => {
    const items = readWishlist()
    updateToggles(items)
    updateHeader(items)
    renderWishlistPage(items)
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-wishlist-toggle]')
    if (toggle) {
      event.preventDefault()
      event.stopPropagation()

      const items = readWishlist()
      const savedIndex = items.findIndex((item) => item.handle === toggle.dataset.productHandle)

      if (savedIndex >= 0) {
        items.splice(savedIndex, 1)
      } else {
        items.push({
          handle: toggle.dataset.productHandle,
          title: toggle.dataset.productTitle,
          url: toggle.dataset.productUrl,
          image: toggle.dataset.productImage,
          price: toggle.dataset.productPrice
        })
      }

      writeWishlist(items)
      return
    }

    const remove = event.target.closest('[data-wishlist-remove]')
    if (!remove) return

    const items = readWishlist().filter((item) => item.handle !== remove.dataset.productHandle)
    writeWishlist(items)
  })

  document.addEventListener(changeEvent, (event) => {
    const items = event.detail?.items || readWishlist()
    updateToggles(items)
    updateHeader(items)
    renderWishlistPage(items)
  })
  document.addEventListener('wishlist:refresh', refresh)
  document.addEventListener('shopify:section:load', refresh)
  window.addEventListener('storage', (event) => {
    if (event.key === storageKey || event.key === null) refresh()
  })

  refresh()
})()
